const SvgWarning = (props) => (
  <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
    <defs>
      <path
        d="M20.654 16.89L13.819 5.05C13.444 4.403 12.747 4 11.997 4s-1.446.403-1.82 1.051L3.28 16.995a2.11 2.11 0 000 2.103 2.11 2.11 0 001.821 1.052h13.795a2.105 2.105 0 001.757-3.26zm-1.757 1.858H5.102a.703.703 0 01-.607-1.052l6.896-11.943a.703.703 0 011.214 0L19.45 17.61a.645.645 0 00.027.043.702.702 0 01-.581 1.094zm-6.898-4.083c.235 0 .564-.16.584-.583l.2-4.072a.784.784 0 00-1.567 0l.2 4.072c.023.444.32.583.583.583zm0 .659a1.004 1.004 0 00-.709 1.71 1.001 1.001 0 10.709-1.71z"
        id="warning_svg__a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="warning_svg__b">
        <use xlinkHref="#warning_svg__a" />
      </mask>
      <use fill="currentColor" fillRule="nonzero" xlinkHref="#warning_svg__a" />
      <g mask="url(#warning_svg__b)">
        <path d="M-.177 0h24v24h-24z" fill="currentColor" />
      </g>
    </g>
  </svg>
)

export default SvgWarning
